import React from "react";
import "./Logo.css";
import logo from "./logo.jpg";

const SHAPES = ["logo--main", "logo--rounded", "logo--framed"];

const SIZES = ["logo--small", "logo--medium", "logo--large"];

const Logo = ({ type, logoShape, logoSize }) => {
  const checkLogoShape = SHAPES.includes(logoShape) ? logoShape : SHAPES[0];

  const checkLogoSize = SIZES.includes(logoSize) ? logoSize : SIZES[1];

  return (
    <div>
      <img
        className={` ${checkLogoShape} ${checkLogoSize}  `}
        type={type}
        src={logo}
        alt="qatar world cup logo"
      />
    </div>
  );
};

export default Logo;
